/*
system-language.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/system-language.service',[
    'system-config'
], function(systemConfig) {
    'use strict';

    /*
     * English, French, German, Spanish, Italian, Japanese
     */
    var supportedLanguages = ['en', 'fr', 'de', 'es', 'it', 'ja', 'he'];

    var serverLanguage = function() {
        if (window.ACCEPTED_LANGUAGE) {
            return window.ACCEPTED_LANGUAGE.replace(/\s/g, '').replace(/q=[0-9.]+,?/g, '').replace(/,/g, ';').split(';')[0];
        }

        return '';
    };

    var isIE11 = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

    // IE11 do not provide preferred language in navigator object. Use language set by server.
    // Use ORIG_ACCEPTED_LANGUAGE instead of ACCEPTED_LANGUAGE as server would change language for HP for RTL scripts.
    var getPreferredLanguageOnIE11 = function() {
        if (!isIE11) {
            return;
        }

        var preferredLanguage = '';
        if (window.ORIG_ACCEPTED_LANGUAGE) {
            return window.ORIG_ACCEPTED_LANGUAGE.split(',')[0];
        }
        return preferredLanguage;
    };

    var browserLanguage = function() {
        return getPreferredLanguageOnIE11() ||
            (navigator.languages && navigator.languages[0]) ||
            navigator.language ||
            navigator.browserLanguage ||
            navigator.systemLanguage ||
            navigator.userLanguage;
    };

    var selectLanguage = function(serverLanguage) {
        var language = window.TEST_LANGUAGE ||
            serverLanguage ||
            browserLanguage() ||
            systemConfig.defaultLang;
        language = language.split('-')[0];
        return language;
    };

    return {
        supportedLanguages: supportedLanguages,
        getSystemLanguage: function() {
            var language = selectLanguage(serverLanguage());

            if (supportedLanguages.indexOf(language) >= 0) {
                return language;
            }

            return 'en';
        },
        browserLanguage: browserLanguage
    };
});

